import "./Contact.module.css";
import NavigationPortal from "@/reusable_sections/Header";
import ConnectWithPrimeHold from "./sections/ConnectWithPrimeHold";
import OurOffices from "./sections/OurOffices";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <NavigationPortal />
      <ConnectWithPrimeHold />
      <OurOffices />
      <Footer />
    </div>;
}